// extracted by mini-css-extract-plugin
export var attachment = "_hk-a";
export var emailContainer = "_hk-4";
export var emailContentPaddedContainer = "_hk-b";
export var emailHeader = "_hk-6";
export var emailIframe = "_hk-3";
export var emailInfoIcon = "_hk-9";
export var emailShortenedSummary = "_hk-e";
export var infoDropdown = "_hk-0";
export var infoRowBoundedContent = "_hk-d";
export var internal = "_hk-5";
export var merchant = "_hk-8";
export var messageInputContainer = "_hk-h";
export var normal = "_hk-7";
export var replyCard = "_hk-f";
export var subtleButton = "_hk-1";
export var subtleButtonIconContainer = "_hk-2";
export var toggleViewRepliesButton = "_hk-c";
export var wrappingText = "_hk-g";